/*
 * Global Components Register
 */

import Vue from 'vue'

import KodHeader from './nav/kod-header.vue'

Vue.component('kod-header', KodHeader)
